import { render, staticRenderFns } from "./ActorCard.vue?vue&type=template&id=93737cde&scoped=true&"
import script from "./ActorCard.vue?vue&type=script&lang=js&"
export * from "./ActorCard.vue?vue&type=script&lang=js&"
import style0 from "./ActorCard.vue?vue&type=style&index=0&id=93737cde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93737cde",
  null
  
)

export default component.exports